<script>
    import registrationTypes from '../config/registrationTypes';
    

    import FormRow from './FormRow.svelte';
    import FormColumn from './FormColumn.svelte';
    import ClaimantSomeoneElse from './ClaimantSomeoneElse.svelte';
    import ClaimantDeceasedEstate from './ClaimantDeceasedEstate.svelte';
    import ContactClaimant from './ContactClaimant.svelte';
    import YesNoGroup from './YesNoGroup.svelte';
    import RadioGroup from './RadioGroup.svelte';
    import AddressAutoComplete from './AddressAutoComplete.svelte';

    import textStore from "../stores/textStore";

    export let disabled = null;
    export let required = null;
    export let claimant;
    export let hasOtherNames=null;
    export let claimantPlaceOfBirth=null;
    export let claimantDateOfBirth=null;
    export let skyDiscoveryClaimantDob=null;

    export let postalAddressIsDifferent = null;  // TODO: set to secondary address
    export let postalAddress = {}

</script>


    
        <ContactClaimant
			bind:firstName={claimant.firstName}
			bind:surname={claimant.surname}
			bind:emailAddress={claimant.emailAddress}
			bind:phoneNumber={claimant.phoneNumber}
			bind:address={claimant.address}
			bind:dateOfBirth={claimantDateOfBirth}
			bind:otherNamesList={claimant.otherNames}
			bind:claimantPlaceOfBirth={claimantPlaceOfBirth}
            bind:hasOtherNames={hasOtherNames}
            bind:skyDiscoveryClaimantDob={skyDiscoveryClaimantDob}
			idPrefix="contactClaimant"
            addressLabel="Home Address"
			{required}
			{disabled}
		/>

        <FormRow>
            <FormColumn>
                <YesNoGroup
                    {required}
			        {disabled}
                    bind:value={postalAddressIsDifferent}
                    name="postalAddressDifferent"
                    label="Is your postal address different to your home address?"
                />
            </FormColumn>
        </FormRow>

        {#if postalAddressIsDifferent==="Yes" && postalAddress != null}
            <AddressAutoComplete 
                bind:addressValid={postalAddress.addressValid}
                bind:manualEntry={postalAddress.manualEntry}
                bind:googlePlaceJson={postalAddress.googlePlaceJson}
                bind:formattedAddress={postalAddress.formattedAddress}
                bind:premise="{postalAddress.premise}"
                bind:subpremise="{postalAddress.subpremise}"
                bind:street="{postalAddress.street}"
                bind:suburb="{postalAddress.suburb}"
                bind:state="{postalAddress.state}"
                bind:postcode="{postalAddress.postcode}"
                bind:country="{postalAddress.country}"
                bind:lat="{postalAddress.lat}"
                bind:lng="{postalAddress.lng}"
                bind:placeId="{postalAddress.placeId}"
                bind:url="{postalAddress.googleMapsUrl}"
                disabled={disabled}
                label="Postal Address"
                {required}>
            </AddressAutoComplete>
        {/if}
